import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { DashboardBackButton } from '@components/utils';
import { SECTION_NAMES } from '@constants/sectionNames';
import { ButtonClean, HeadContent, Loading, useModalContext } from '@fourthwall/components';
import { reverse, routing } from '@utils/routing';
import { AppsSpotifySkeleton } from './AppsSpotifySkeleton';
import { AddMembersOnlyAudio } from './components/AddMembersOnlyAudio/AddMembersOnlyAudio';
import { AddPodcastButton } from './components/AddPodcastButton/AddPodcastButton';
import { Podcast } from './components/Podcast/Podcast';
import { PodcastsList } from './components/PodcastsList/PodcastsList';
import { usePodcastsQuery } from './hooks/usePodcastsQuery';
import { NewPodcastModal } from './modules/NewPodcastModal';
export const AppsSpotify = () => {
    const navigate = useNavigate();
    const modal = useModalContext();
    const { podcastsQuery } = usePodcastsQuery();
    if (!podcastsQuery.data)
        return React.createElement(AppsSpotifySkeleton, null);
    const renderContent = () => {
        if (podcastsQuery.data.podcasts.length === 0)
            return React.createElement(AddMembersOnlyAudio, { onClick: () => modal.open(NewPodcastModal) });
        return (React.createElement(Loading, { isLoading: podcastsQuery.isFetching },
            React.createElement(PodcastsList, null,
                podcastsQuery.data?.podcasts.map((podcast) => (React.createElement(Podcast, { key: podcast.id, status: podcast.status, artworkUrl: podcast.imageUrl, title: podcast.name, url: podcast.spotifyUrl, onClick: () => {
                        navigate(reverse(routing.apps.spotify.podcast.self, {
                            podcastId: podcast.id,
                        }));
                    } }))),
                React.createElement(AddPodcastButton, { onClick: () => modal.open(NewPodcastModal) }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: SECTION_NAMES.appSpotify }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: SECTION_NAMES.appSpotify, topContent: React.createElement(DashboardBackButton, { label: SECTION_NAMES.apps, to: routing.apps.self }), bottomContent: React.createElement("p", { style: { lineHeight: '150%' } },
                    "Allow members to listen to your audio posts on Spotify. Only spoken audio content is allowed. Music and musical content are not accepted by Spotify and will be taken down.",
                    ' ',
                    React.createElement(ButtonClean, { label: "Learn more", withUnderline: true, href: "https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify", target: "_blank" })) }, renderContent()))));
};
